import { Injectable } from '@angular/core';

import { Team } from './team';
import { TEAMS } from './teams';
import { MOCKTEAMS } from './mock-teams';

@Injectable()
export class TeamsService {

  getTeams(): Promise<Team[]> {
    return Promise.resolve(TEAMS);
  }

  getMockTeams(): Promise<Team[]> {
    return Promise.resolve(MOCKTEAMS);
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/kanban/components/strategy-overview/teams/teams.service.ts